import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const DigitalCameraWorld: Site = {
  id: 'digitalcameraworld',
  logo: 'svg/digitalcameraworld.svg',
  label: 'Digital Camera World',
  analyticsName: 'dcw',
  hostname: 'digitalcameraworld.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
